import { useState, useEffect } from 'react';

export default function useDataTime(keyInfomatData: any) {
  const [dataTime, setDataTime] = useState('');

  useEffect(() => {
    const date = keyInfomatData?.date;
    if (date) {
      setDataTime(date);
    }
  }, [keyInfomatData]);

  return {
    dataTime,
  };
}
